export const chatExecutionResources = {
  "zh-CN": {
    execution: {
      warning: {
        embeddingUnavailable: "向量检索暂不可用，已使用关键词检索",
        expansionFailed: "查询扩展失败，已按原始问题检索",
        topicRoutingFailed: "主题路由失败，已扩大检索范围",
        retrievalLegFailure: "部分检索通道失败，结果可能不完整",
        guideExpansionFailed: "检索引导扩展失败",
        rerankFailed: "结果排序失败，已返回原始检索结果",
        rerankUnavailable: "结果排序功能暂不可用",
        sourceMismatch: "来源校验不匹配，相关结果已过滤",
      },
      organize: {
        filesListed: "列出 {{count}} 个文件，共 {{totalCount}} 个可见文件",
        filesRead: "处理 {{count}} 个文件 · {{failedCount}} 个未能读取",
        tagFieldsListed: "找到 {{count}} 个可用标签字段",
        proposalsSubmitted: "提交 {{count}} 条提案 · {{warningCount}} 条有提示 · {{failedCount}} 条失败",
      },
      stopped: "已停止",
      interrupted: "未完成",
      failed: "失败",
      complete: "已完成",
      running: "进行中",
      elapsed: "耗时 {{duration}}",
      thinking: "思考",
      retry: "自动重试",
      retryCount: "第 {{attempt}}/{{maxAttempts}} 次",
      compact: "压缩上下文",
      searchKnowledge: "检索知识库",
      readFile: "阅读文件",
      searchWeb: "搜索公开资料",
      resultCount: "命中 {{count}} 条",
      resultCount_one: "命中 {{count}} 条",
      resultCount_other: "命中 {{count}} 条",
      incompleteResultCount: "命中 {{count}} 条 · 部分检索未完成",
      incompleteResultCount_one: "命中 {{count}} 条 · 部分检索未完成",
      incompleteResultCount_other: "命中 {{count}} 条 · 部分检索未完成",
      queryResultCount: "查询：{{query}} · 命中 {{count}} 条",
      queryResultCount_one: "查询：{{query}} · 命中 {{count}} 条",
      queryResultCount_other: "查询：{{query}} · 命中 {{count}} 条",
      incompleteQueryResultCount: "查询：{{query}} · 命中 {{count}} 条 · 部分检索未完成",
      incompleteQueryResultCount_one: "查询：{{query}} · 命中 {{count}} 条 · 部分检索未完成",
      incompleteQueryResultCount_other: "查询：{{query}} · 命中 {{count}} 条 · 部分检索未完成",
      query: "查询：{{value}}",
      question: "提问：{{value}}",
      askUserWaiting: "已转交用户，等待回答：{{question}}",
      toolFailed: "执行失败",
      toolGeneric: "调用工具 {{toolName}}",
      resultBreakdown: "命中 {{count}} 条 · 新增 {{newCount}} 条，复用 {{reusedCount}} 条",
      searchNoResults: "检索完成，未找到相关公开资料",
      reused: "复用本轮已有检索，未再次搜索",
      fileProgress: "{{filename}} · 已读 {{completed}}/{{total}} {{unit}}",
      pages: "页",
      segments: "段",
      referenceCount: "{{count}} 项",
      evidence: "本次读取的资料",
      process: "执行过程",
      failedProcess: "执行未完成",
      working: "正在工作",
      toolsSummary: "{{count}} 个工具",
      toolsSummary_one: "{{count}} 个工具",
      toolsSummary_other: "{{count}} 个工具",
      searchesSummary: "检索 {{count}} 次",
      searchesSummary_one: "检索 {{count}} 次",
      searchesSummary_other: "检索 {{count}} 次",
      filesSummary: "阅读 {{count}} 个文件",
      filesSummary_one: "阅读 {{count}} 个文件",
      filesSummary_other: "阅读 {{count}} 个文件",
      totalTimeSummary: "共 {{duration}} s",
      failedReading: "读取失败",
      reading: "正在阅读",
      readComplete: "阅读完成",
      progress: "已读 {{completed}}/{{total}} {{unit}}",
      source: "来源",
      materializedSource: "使用解析语料",
      originalSource: "原始文件",
      imageProgress: "已查看 {{completed}}/{{total}} 张图片或页面预览",
      compressedBefore: "压缩前 {{tokens}}",
      viewArtifact: "查看产物",
      tool: {
        read_file: "阅读文件",
        list_kb_overview: "浏览知识库",
        search_knowledge_base: "检索知识库",
        read_kb_document: "读取知识库原文",
        read_office_objects: "读取 Office 结构",
        read_knowledge_office_objects: "读取知识库来源结构",
        ask_user: "向用户提问",
        browse_kb_document_structure: "浏览文档章节",
        search_web: "搜索公开资料",
        search_pubmed: "检索医学文献",
        search: "联网检索",
        query_facts: "查询结构化知识",
        ontology_overview: "浏览知识本体",
        ontology_lookup: "查询知识本体",
        assets_overview: "浏览数据资产",
        doccenter_overview: "浏览文档中心",
        list_doccenter_files: "列出文档中心文件",
        read_doccenter_files: "阅读文档中心文件",
        list_tag_fields: "查询标签词表",
        propose_doc_organize: "提交整理提案",
        list_knowledge_bases: "列出知识库",
        inspect_kb: "检查知识库",
        search_kb_content: "检索知识库内容",
        list_pending_kb_relations: "列出待裁决文档关系",
        generate_document: "生成文档",
        save_spec: "保存规范",
      },
      agentRun: {
        started: "正在准备执行环境",
        loadingFiles: "正在加载会话附件",
        filesLoaded: "已加载 {{count}} 个附件",
        executing: "Agent 开始执行",
        completed: "Agent 执行完成",
        cancelled: "运行已取消",
        failed: "运行失败：{{error}}",
        taskStep: "第 {{stepNumber}} 步完成",
        toolStarted: "调用工具 {{toolName}}",
        toolCompleted: "工具完成 {{toolName}}",
        toolFailed: "工具失败 {{toolName}}",
        artifactCreated: "产出文件 {{name}}",
        artifactSaved: "产物已保存到项目",
        empty: "暂无执行过程。发起任务后，这里会实时展示 Agent 的执行步骤与工具调用。",
        input: "入参：{{value}}",
        output: "出参：{{value}}",
      },
      research: {
        cancelled: "研究已停止",
        cancelledWithError: "研究已停止：{{error}}",
        failed: "研究失败",
        failedWithError: "研究失败：{{error}}",
        title: "研究进度",
        planning: "正在分析问题，制定研究计划",
        answerReceived: "已收到回答，正在继续研究",
        waitingForTask: "等待研究任务执行",
        waitingForAnswer: "等待回答：{{question}}",
        timeoutDefault: "等待回答超时，已基于研究上下文自动选定默认答案，继续研究",
        stepProgress: "已完成 {{completed}}/{{total}} 个研究子问题",
        summarizing: "正在核对证据并汇总回答",
        htmlReport: "正在生成 HTML 研究报告",
        needClarification: "研究需要你澄清",
        answerPlaceholder: "输入你的回答…",
        submitAnswer: "提交回答",
        submittingAnswer: "提交中…",
        answerSubmitFailed: "回答提交失败，请重试。",
        retryProgress: "重新获取研究进度",
        stop: "停止研究",
        stopFailed: "停止失败，请重试。",
        record: "研究记录",
        subQuestion: "研究子问题 {{index}}",
        characters_one: "{{count}} 字",
        characters_other: "{{count}} 字",
        tools_one: "{{count}} 次工具",
        tools_other: "{{count}} 次工具",
      },
    },
  },
  "en-US": {
    execution: {
      warning: {
        embeddingUnavailable: "Vector search is unavailable; keyword search was used",
        expansionFailed: "Query expansion failed; the original query was used",
        topicRoutingFailed: "Topic routing failed; the search scope was expanded",
        retrievalLegFailure: "Some retrieval paths failed, so results may be incomplete",
        guideExpansionFailed: "Retrieval guidance could not be expanded",
        rerankFailed: "Reranking failed; the original search results were returned",
        rerankUnavailable: "Reranking is unavailable",
        sourceMismatch: "Source verification failed; affected results were filtered out",
      },
      organize: {
        filesListed: "Listed {{count}} files out of {{totalCount}} visible files",
        filesRead: "Processed {{count}} files · {{failedCount}} could not be read",
        tagFieldsListed: "Found {{count}} available tag fields",
        proposalsSubmitted: "Submitted {{count}} proposals · {{warningCount}} with notes · {{failedCount}} failed",
      },
      stopped: "Stopped",
      interrupted: "Interrupted",
      failed: "Failed",
      complete: "Completed",
      running: "In progress",
      elapsed: "Took {{duration}}",
      thinking: "Thinking",
      retry: "Automatic retry",
      retryCount: "Attempt {{attempt}} of {{maxAttempts}}",
      compact: "Compact context",
      searchKnowledge: "Search knowledge base",
      readFile: "Read file",
      searchWeb: "Search public sources",
      resultCount: "Found {{count}} results",
      resultCount_one: "Found {{count}} result",
      resultCount_other: "Found {{count}} results",
      incompleteResultCount: "Found {{count}} results · Some searches did not finish",
      incompleteResultCount_one: "Found {{count}} result · Some searches did not finish",
      incompleteResultCount_other: "Found {{count}} results · Some searches did not finish",
      queryResultCount: "Query: {{query}} · Found {{count}} results",
      queryResultCount_one: "Query: {{query}} · Found {{count}} result",
      queryResultCount_other: "Query: {{query}} · Found {{count}} results",
      incompleteQueryResultCount: "Query: {{query}} · Found {{count}} results · Some searches did not finish",
      incompleteQueryResultCount_one: "Query: {{query}} · Found {{count}} result · Some searches did not finish",
      incompleteQueryResultCount_other: "Query: {{query}} · Found {{count}} results · Some searches did not finish",
      query: "Query: {{value}}",
      question: "Question: {{value}}",
      askUserWaiting: "Sent to the user and waiting for a response: {{question}}",
      toolFailed: "Execution failed",
      toolGeneric: "Calling tool {{toolName}}",
      resultBreakdown: "Found {{count}} results · {{newCount}} new, {{reusedCount}} reused",
      searchNoResults: "Search completed, no relevant public sources found",
      reused: "Reused this turn’s search results",
      fileProgress: "{{filename}} · Read {{completed}}/{{total}} {{unit}}",
      pages: "pages",
      segments: "segments",
      referenceCount: "{{count}} items",
      evidence: "Sources read this turn",
      process: "Execution",
      failedProcess: "Execution incomplete",
      working: "Working",
      toolsSummary: "{{count}} tools",
      toolsSummary_one: "{{count}} tool",
      toolsSummary_other: "{{count}} tools",
      searchesSummary: "{{count}} searches",
      searchesSummary_one: "{{count}} search",
      searchesSummary_other: "{{count}} searches",
      filesSummary: "Read {{count}} files",
      filesSummary_one: "Read {{count}} file",
      filesSummary_other: "Read {{count}} files",
      totalTimeSummary: "{{duration}} s total",
      failedReading: "Read failed",
      reading: "Reading",
      readComplete: "Reading complete",
      progress: "Read {{completed}}/{{total}} {{unit}}",
      source: "Source",
      materializedSource: "Parsed content",
      originalSource: "Original file",
      imageProgress: "Viewed {{completed}}/{{total}} image or page previews",
      compressedBefore: "Before compaction: {{tokens}}",
      viewArtifact: "View artifact",
      tool: {
        read_file: "Read file",
        list_kb_overview: "Browse knowledge base",
        search_knowledge_base: "Search knowledge base",
        read_kb_document: "Read source document",
        read_office_objects: "Read Office structure",
        read_knowledge_office_objects: "Read knowledge source structure",
        ask_user: "Ask the user",
        browse_kb_document_structure: "Browse document sections",
        search_web: "Search public sources",
        search_pubmed: "Search medical literature",
        search: "Search the web",
        query_facts: "Query structured knowledge",
        ontology_overview: "Browse knowledge ontology",
        ontology_lookup: "Query knowledge ontology",
        assets_overview: "Browse data assets",
        doccenter_overview: "Browse documents",
        list_doccenter_files: "List document files",
        read_doccenter_files: "Read document files",
        list_tag_fields: "Query tag vocabulary",
        propose_doc_organize: "Submit organization proposal",
        list_knowledge_bases: "List knowledge bases",
        inspect_kb: "Inspect knowledge base",
        search_kb_content: "Search knowledge base content",
        list_pending_kb_relations: "List pending document relations",
        generate_document: "Generate document",
        save_spec: "Save specification",
      },
      agentRun: {
        started: "Preparing the execution environment",
        loadingFiles: "Loading conversation attachments",
        filesLoaded: "Loaded {{count}} attachments",
        executing: "Agent started",
        completed: "Agent completed",
        cancelled: "Run cancelled",
        failed: "Run failed: {{error}}",
        taskStep: "Step {{stepNumber}} completed",
        toolStarted: "Calling tool {{toolName}}",
        toolCompleted: "Tool completed: {{toolName}}",
        toolFailed: "Tool failed: {{toolName}}",
        artifactCreated: "Created file {{name}}",
        artifactSaved: "Artifact saved to the project",
        empty: "No execution details yet. Steps and tool calls will appear here after you start a task.",
        input: "Input: {{value}}",
        output: "Output: {{value}}",
      },
      research: {
        cancelled: "Research stopped",
        cancelledWithError: "Research stopped: {{error}}",
        failed: "Research failed",
        failedWithError: "Research failed: {{error}}",
        title: "Research progress",
        planning: "Analyzing the question and preparing a research plan",
        answerReceived: "Answer received. Research is continuing.",
        waitingForTask: "Waiting for the research task to run",
        waitingForAnswer: "Waiting for an answer: {{question}}",
        timeoutDefault: "The answer timed out. Continuing with a default based on the research context.",
        stepProgress: "Completed {{completed}} of {{total}} research questions",
        summarizing: "Checking evidence and preparing the summary",
        htmlReport: "Generating the HTML research report",
        needClarification: "More information is needed",
        answerPlaceholder: "Enter your answer…",
        submitAnswer: "Submit answer",
        submittingAnswer: "Submitting…",
        answerSubmitFailed: "Could not submit your answer. Please try again.",
        retryProgress: "Reload research progress",
        stop: "Stop research",
        stopFailed: "Could not stop research. Please try again.",
        record: "Research notes",
        subQuestion: "Research question {{index}}",
        characters_one: "{{count}} character",
        characters_other: "{{count}} characters",
        tools_one: "{{count}} tool call",
        tools_other: "{{count}} tool calls",
      },
    },
  },
} as const;
